var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-controller',_vm._b({},'base-controller',{ ..._vm.$props, ..._vm.$attrs },false),[_c('display-base',[_c('div',_vm._g({staticClass:"display-led handle",style:({ '--size': _vm.size })},_vm.controlHandlers),[_c('div',{staticClass:"display-led__content"},[_vm._v(" "+_vm._s(_vm.displayValue)+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }